import { action } from 'mobx';
import { SessionStore } from './session.store';
import { AggregateFunction, AgtAnalyticsStore } from './agt.analytics.store';

export interface IAgtClusterModel {
	agtId: number;
	bm: number;
	ub: number;
	vbl: number;
	bsg: number;
	vas: number;
	kvs: number;
	kme: number;
	bbs: number;
	bfe: number;
	fb: number;
}

export class AgtClusterModel implements IAgtClusterModel {
	agtId: number;
	bm: number;
	ub: number;
	vbl: number;
	bsg: number;
	vas: number;
	kvs: number;
	kme: number;
	bbs: number;
	bfe: number;
	fb: number;

	constructor(data: any) {
		this.agtId = data.aid || 0;
		this.bm = data.bm ? parseInt(data.bm) : 0;
		this.ub = data.ub ? parseInt(data.ub) : 0;
		this.vbl = data.vbl ? parseInt(data.vbl) : 0;
		this.bsg = data.bsg ? parseInt(data.bsg) : 0;
		this.vas = data.vas ? parseInt(data.vas) : 0;
		this.kvs = data.kvs ? parseInt(data.kvs) : 0;
		this.kme = data.kme ? parseInt(data.kme) : 0;
		this.bbs = data.bbs ? parseInt(data.bbs) : 0;
		this.bfe = data.bfe ? parseInt(data.bfe) : 0;
		this.fb = data.fb ? parseInt(data.fb) : 0;
	}
}

export class AgtClusterStore extends AgtAnalyticsStore {
	constructor(session: SessionStore) {
		super(session, {
			tableName: 'agentur_cluster',
			defaultColumns: [
				{ column: 'vtnr_id', aggregateFunction: AggregateFunction.NONE, alias: 'aid' },
				{ column: 'bm', aggregateFunction: AggregateFunction.NONE },
				{ column: 'ub', aggregateFunction: AggregateFunction.NONE },
				{ column: 'vbl', aggregateFunction: AggregateFunction.NONE },
				{ column: 'bsg', aggregateFunction: AggregateFunction.NONE },
				{ column: 'vas', aggregateFunction: AggregateFunction.NONE },
				{ column: 'kvs', aggregateFunction: AggregateFunction.NONE },
				{ column: 'kme', aggregateFunction: AggregateFunction.NONE },
				{ column: 'bbs', aggregateFunction: AggregateFunction.NONE },
			{ column: 'bfe', aggregateFunction: AggregateFunction.NONE },
			{ column: 'fb', aggregateFunction: AggregateFunction.NONE },
			],
		});
		this.queryName = '?cluster';
	}

	@action
	async loadByBm(bm: number): Promise<AgtClusterModel[]> {
		const whereClause = 'bm = ' + bm;
		const results = await this.query(this.config.defaultColumns, whereClause);
		return results.map((data) => new AgtClusterModel(data));
	}

	@action
	async loadAgtByBm(agtId: number, bm: number): Promise<AgtClusterModel[]> {
		const whereClause = 'a.vtnr_id = ' + agtId + ' AND bm = ' + bm;
		const results = await this.query(this.config.defaultColumns, whereClause);
		return results.map((data) => new AgtClusterModel(data));
	}

	@action
	async findAll(): Promise<AgtClusterModel[]> {
		const results = await this.query(this.config.defaultColumns);
		return results.map((data) => new AgtClusterModel(data));
	}
}
